module.exports = __webpack_public_path__ + "static/img/icon-保险@2x.e2cd91c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-保险@2x.png
// module id = yPCH
// module chunks = 4